import type { ReactNode } from 'react';

/**
 * Default container for a list of rendered resources — a plain stacked
 * column. Items inside carry `ctx.inList: true`, so entity views pick their
 * row/compact variant themselves. Parents wanting a different container
 * place `slotItems.<field>` in their own box instead; tabular/aligned
 * layouts are curated collection views, never emergent from the walker.
 */
export function FhirList({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div data-fhir-list="" className={className ?? 'flex flex-col gap-2'}>
      {children}
    </div>
  );
}
